/* eslint-disable spellcheck/spell-checker */
require('dotenv').config()
const pkg = require('../package.json')
const program = require('commander')
const PowerBiAdapter = require('./PowerBiAdapter')

function parseOption (v) {
  return v
}

program
  .version(pkg.name + '@' + pkg.version)
  .description('Generate embed token from command line')
  .usage('[options] <file ...>')
  .option('-u, --pbiUsername <n>', 'PowerBi username', parseOption, process.env['PBI_USERNAME'])
  .option('-p, --pbiPassword <n>', 'PowerBi password', parseOption, process.env['PBI_PASSWORD'])
  .option('-s, --pbiRessource <n>', 'PowerBi Resource', parseOption, process.env['PBI_RESSOURCE'])
  .option('-c, --pbiClientId <n>', 'PowerBi Client ID', parseOption, process.env['PBI_CLIENT_ID'])
  .option('-t, --pbiTenant <n>', 'PowerBi tenant', parseOption, process.env['PBI_TENANT'])
  .option('-g, --groupId <n>', 'Group Id', parseOption, process.env['GROUP_ID'])
  .option('-r, --reportId <n>', 'Report Id', parseOption, process.env['REPORT_ID'])
  .parse(process.argv)

function main () {
  const reqBody = { 'groupId': program.groupId, 'reportId': program.reportId }
  const configs = {
    pbiUsername: program.pbiUsername,
    pbiPassword: program.pbiPassword,
    pbiRessource: program.pbiRessource,
    pbiClientId: program.pbiClientId,
    pbiTenant: program.pbiTenant
  }
  const powerBiAdapter = new PowerBiAdapter(configs)

  powerBiAdapter.getPowerBiEmbedToken(reqBody)
    .then(function (result) {
      console.log(result)
    }).catch(function (error) {
      console.log('ERROR >>>>>>>>>>>>>>>>')
      console.log(error.message)
    })
}

main()
